import DeletePresentationVideoModalComponent from "./DeletePresentationVideoModalComponent"

export default DeletePresentationVideoModalComponent;